export class Province {
	id: string;
	country_id: string;
	name: string;

	constructor() {
	}
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/province.ts